var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9095_5671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9095_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9095_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 11.2929L15.5352 14.121C13.9737 15.6835 11.4405 15.6835 9.879 14.121C9.63291 13.8759 9.44053 13.5995 9.27156 13.3144L10.586 11.9999C10.6485 11.9369 10.7257 11.9008 10.7994 11.8583C10.8902 12.1689 11.0489 12.4628 11.2931 12.7069C12.0728 13.4872 13.3419 13.4863 14.1212 12.7069L16.9493 9.87882C17.7296 9.09854 17.7296 7.82997 16.9493 7.05019C16.17 6.27041 14.9015 6.27041 14.1212 7.05019L13.1153 8.05704C12.2994 7.73916 11.42 7.65372 10.564 7.77919L12.7071 5.63613C14.2696 4.07413 16.8018 4.07413 18.3643 5.63613C19.9259 7.19819 19.9259 9.73091 18.3643 11.2929ZM10.8853 15.9433L9.879 16.9502C9.09922 17.7295 7.83016 17.7295 7.05037 16.9502C6.27059 16.1699 6.27059 14.9013 7.05037 14.1211L9.879 11.2929C10.6593 10.5127 11.9273 10.5127 12.7071 11.2929C12.9508 11.5366 13.1095 11.8305 13.2013 12.1406C13.2755 12.0976 13.3517 12.0625 13.4142 12L14.7287 10.686C14.5607 10.3999 14.3673 10.1245 14.1212 9.87888C12.5597 8.31688 10.0265 8.31688 8.46447 9.87888L5.63634 12.707C4.07434 14.2695 4.07434 16.8017 5.63634 18.3642C7.19834 19.9258 9.73106 19.9258 11.2931 18.3642L13.4367 16.2207C12.5802 16.3466 11.7008 16.2607 10.8853 15.9433Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9095_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.9e0b7af9c8582d5d49403ed771be75cc.svg";
export { ForwardRef as ReactComponent };